import React from 'react';
import { Alert, Button, Form, FormGroup, Input, Row, Col } from 'reactstrap';
import config from '../../config';
import { TOKEN_KEY } from '../../constants';

class AddEditForm extends React.Component {
    state = {
        id: 0,
        REQUEST_ID: '',
        NOTES: '',
        REQUESTOR_AUTHORIZED: '',
        PARENT_GUARDIAN_FLAG: '',
        hideAlert: true,
        hideAlert2: true
    }

    onChange = e => {
        this.setState({ [e.target.name]: e.target.value } )
        //console.log(e.target.value)
    }

    onChecked = e => {
        this.setState({
            [e.target.name]: e.target.checked,
            hideAlert: false
        })
        //console.log(e.target.checked)
    }

    submitFormEdit = e => {
        e.preventDefault()
        return new Promise((resolve, reject) => {
            const req = new XMLHttpRequest();
            const submitUrl = config.api + '/request/' + this.state.REQUEST_ID;
            req.open('POST', submitUrl);
            req.setRequestHeader('Content-Type', 'application/json');
            req.setRequestHeader("Authorization", sessionStorage.getItem(TOKEN_KEY));
            req.addEventListener('load', () => {
                if (req.status >= 200 && req.status < 300) {
                    // got this from the fetch polyfill, keeping it to be safe
                    const responseBody = 'response' in req ? req.response : req.responseText;
                    const results = JSON.parse(responseBody);
                    resolve(results);
                    //console.log(results);
                    this.props.toggle()
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }
                else {
                    let error;
                    error = new Error(`server_error: ${req.statusText}`);
                    error.statusText = req.statusText;
                    reject(error);
                }
            });

            req.addEventListener('error', () => {
                const error = new Error('client_error: Network request failed');
                error.statusText = req.statusText;
                reject(error);
                this.setState({
                    hideAlert2: false
                })
            });

            req.addEventListener('abort', () => {
                const error = new Error('client_error: Request aborted');
                error.statusText = req.statusText;
                reject(error);
                this.setState({
                    hideAlert2: false
                })
            });

            req.addEventListener('timeout', () => {
                const error = new Error('client_error: Request timed out');
                error.statusText = req.statusText;
                reject(error);
                this.setState({
                    hideAlert2: false
                })
            });

            req.send(
                JSON.stringify({
                    NOTES: this.state.NOTES,
                    REQUESTOR_AUTHORIZED: this.state.REQUESTOR_AUTHORIZED
                })
            );
        });
    }

    componentDidMount() {
        // if item exists, populate the state with proper data
        if (this.props.item) {
            const { id, REQUEST_ID, PARENT_GUARDIAN_FLAG, REQUESTOR_AUTHORIZED, NOTES } = this.props.item
            this.setState({ id, REQUEST_ID, PARENT_GUARDIAN_FLAG, REQUESTOR_AUTHORIZED, NOTES })
        }
    }

    render() {
        const style = this.state.hideAlert ? { display: 'none' } : {};
        const style2 = this.state.hideAlert2 ? { display: 'none' } : {};

        return (

            <Form onSubmit={this.props.item ? this.submitFormEdit : this.submitFormAdd}>
                <Row>
                    <Col xs="12">
                        <Alert color="danger" style={style2}>
                            There is a problem. This request has not been processed. Please try submitting again.
                            If problem persists, please contact the Help Desk
                        </Alert>
                    </Col>
                    <Col xs="12">
                        <h3>Request ID {this.state.REQUEST_ID}</h3>
                    </Col>
                    <Col xs="12">
                        <Alert color="success" style={style}>
                            Thank You for Verifying this individual has Authority to File on Behalf of Minor/Dependent. Click SUBMIT to Confirm.
                            (Close this window to cancel changes)
                        </Alert>
                    </Col>
                    {(() => {
                        if (this.state.PARENT_GUARDIAN_FLAG === 1 && this.state.REQUESTOR_AUTHORIZED === null) {
                            return (
                                <React.Fragment>
                                    <Col xs="12">
                                        <FormGroup>
                                            <input
                                                type="checkbox"
                                                name="REQUESTOR_AUTHORIZED"
                                                id="REQUESTOR_AUTHORIZED"
                                                onChange={this.onChecked}
                                                className="checkboxInput"
                                                value={this.state.REQUESTOR_AUTHORIZED === null ? '' : this.state.REQUESTOR_AUTHORIZED}
                                            />{' '}
                                            <label
                                                className="checkboxLabel"
                                                id="REQUESTOR_AUTHORIZED"
                                                htmlFor="REQUESTOR_AUTHORIZED"
                                            >
                                              Verified individual has authority to file on behalf of Minor/Dependent
                                            </label>
                                        </FormGroup>
                                        <hr/>
                                    </Col>
                                </React.Fragment>
                            );
                        }
                        else if (this.state.PARENT_GUARDIAN_FLAG === 1 && this.state.REQUESTOR_AUTHORIZED === 1) {
                            return (
                                <React.Fragment>
                                    <Col xs="12">
                                        <FormGroup>
                                            <input checked disabled
                                                type="checkbox"
                                                name="REQUESTOR_AUTHORIZED"
                                                id="REQUESTOR_AUTHORIZED"
                                                onChange={this.onChecked}
                                                className="checkboxInput disabled"
                                                value={this.state.REQUESTOR_AUTHORIZED}
                                            />{' '}
                                            <label
                                                className="checkboxLabel disabled"
                                                id="REQUESTOR_AUTHORIZED"
                                                htmlFor="REQUESTOR_AUTHORIZED"
                                            >
                                                Verified individual has authority to file on behalf of Minor/Dependent
                                            </label>
                                        </FormGroup>
                                        <hr/>
                                    </Col>
                                </React.Fragment>
                            );
                        }
                    })()}
                </Row>
                <Row>
                    <Col xs="12">
                        <h4>Notes</h4>
                    </Col>
                    <Col xs="12">
                        <FormGroup>
                            <Input type="textarea" name="NOTES" id="NOTES" onChange={this.onChange} value={this.state.NOTES === null ? '' : this.state.NOTES} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12">
                        <Button color="primary" size="lg" block>Submit</Button>
                    </Col>
                </Row>
            </Form>
        );
    }
}

export default AddEditForm